import { useEffect } from 'react'

import { cleanCartData } from '../../helpers/userData'
import { getTranslate } from '../../localization'
import { ConfirmPrimitiveReservation } from '../../types/cart'
import BookerDetailsSummary from './components/BookerDetailsSummary'
import GuestDetailsSummary from './components/GuestDetailsSummary'
import PriceDetails from './components/PriceDetails'
import SelectedRoomList from './components/SelectedRoomList'

type StepThreeProps = {
  confirmData: ConfirmPrimitiveReservation | undefined
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>
  setRedirectTitle: React.Dispatch<React.SetStateAction<string>>
  isTimeExpired: boolean
}
const StepThree = ({
  confirmData,
  isTimeExpired,
  setShowModal,
  setRedirectTitle
}: StepThreeProps) => {
  useEffect(() => {
    if (isTimeExpired) {
      setRedirectTitle(
        getTranslate(
          'Your time has been expired. You will be redirect to booking page'
        )
      )
      setShowModal(true)
      cleanCartData()
      localStorage.removeItem('confirmPrimitiveInput')
      localStorage.removeItem('confirmPrimitiveReservationState')
      localStorage.removeItem('hotelDetails')
      localStorage.removeItem('primitiveData')
    }
  }, [isTimeExpired])

  return confirmData?.reservationInfo.detailedRoomStays.length ? (
    <>
      <SelectedRoomList items={confirmData?.reservationInfo.selectedRooms} />
      <BookerDetailsSummary booker={confirmData?.reservationInfo.booker} />
      <GuestDetailsSummary
        detailedRoomStays={confirmData?.reservationInfo.detailedRoomStays}
      />
      <PriceDetails
        detailedRoomStays={confirmData?.reservationInfo.detailedRoomStays}
        curruncy={confirmData?.paymentInfo.currency}
      />
    </>
  ) : (
    <></>
  )
}

export default StepThree
